export class InvCardEntity{
    id:number;
    code:string;
    cyclicId:number;
    coutingType:string;
    date:string;
    status:string;
    auditorId:number;
    auditor:string;
    cyclic:string;
    customer:string;
    loadDate:string;
    location:string;
    total:number;
    sampling:number;

    constructor(){}
}